import {
  LookupSource,
  LookupOption,
  createEntireLoadLookupSource,
  EMPTY_LOOKUP_SOURCE,
} from '@/components';
import {
  RtkqSpin,
  useLazyGetClientsListQuery,
  useUserContextSelector,
} from '@/redux';
import { isArray } from 'lodash';
import { useMemo } from 'react';

export function mapClientLookup(value: {
  name: string;
  id: string;
}): LookupOption {
  return {
    _search: value.name,
    label: value.name,
    value: value.id,
  };
}

export function useClientLookupSource(): LookupSource {
  const [fetchList] = useLazyGetClientsListQuery();
  const [isBfpAdmin, clientId] = useUserContextSelector((x) => [
    x.isBFP,
    x.clientId,
  ]);
  var hasManyClient = isBfpAdmin || (isArray(clientId) && clientId.length > 1);
  return useMemo(() => {
    if (!hasManyClient) {
      return EMPTY_LOOKUP_SOURCE;
    }

    return createEntireLoadLookupSource({
      initial: (id: string) =>
        fetchList({ [RtkqSpin]: false }, true)
          .unwrap()
          .then((values) => mapClientLookup(values.find((x) => x.id === id)!)),
      load: () =>
        fetchList({ [RtkqSpin]: false }, true)
          .unwrap()
          .then((values) => values.map(mapClientLookup)),
    });
  }, [fetchList, hasManyClient]);
}
